
<div class="row mb-3">
  <div class="col-12">
    <h4 class="card-title">Taxa De Aterro Zero</h4>
  </div>
</div>

<dg-table dg-dynamic-table [dynamicTable]="tableLixoZero"></dg-table>
